export enum FormStaticTypeEnum {
  DescriptionStatic = 'DescriptionStatic',
  ImageStatic = 'ImageStatic',
  RatingStatic = 'RatingStatic',
  ButtonStatic = 'ButtonStatic',
}
